export enum Combinator {
  Or = 'Or',
  And = 'And',
  Not = 'Not',
}

export const OR = Combinator.Or;
export const AND = Combinator.And;
export const NOT = Combinator.Not;
